import React from 'react';

import { useOpenAgentChat } from '@lumapps/agent-chat-global/hooks/useOpenAgentChat';

import { PAGE_WRITER_AGENT_ID } from '../constants';

const PAGE_WRITER_CONFIG = {
    agentId: PAGE_WRITER_AGENT_ID,
    initialMessages: [],
};

export const useOpenPageWriterAgent = () => {
    const openAgentChat = useOpenAgentChat();

    return React.useCallback(() => {
        openAgentChat(PAGE_WRITER_CONFIG);
    }, [openAgentChat]);
};
